import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWhatsapp
} from '@fortawesome/free-brands-svg-icons';
import {
  faEnvelopeOpen,
  faPaperPlane
} from '@fortawesome/free-solid-svg-icons';
import './verification.css';
import { Link, useLocation } from 'react-router-dom';
import { apiRequest } from '../../config/api';
import { useTranslation } from 'react-i18next';

const EmailVerification = () => {
  const location = useLocation();
  const email = location.state?.email || '';
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const { t } = useTranslation();

  const handleResend = async () => {
    setError('');
    setSuccess('');
    setLoading(true);
    if (!email) {
      setError(t('verification.sentTo') + ' ' + t('signup.placeholderEmail'));
      setLoading(false);
      return;
    }
    // Reenvia o email de redefinição de senha via backend
    try {
      const data = await apiRequest('/auth/resend-reset-password', {
        method: 'POST',
        body: JSON.stringify({ email }),
      });
      setLoading(false);
      if (data.success) {
        setSuccess(t('fpassword.resend'));
      } else {
        setError(t('fpassword.errorSend'));
      }
    } catch (error) {
      setLoading(false);
      setError(t('fpassword.errorSend'));
    }
  };

  return (
    <div className="email-verification-page">
      <div className="verification-container">
        {/* Logo Section */}
        <div className="logo-section">
          <div className="logo-wrapper">
            <FontAwesomeIcon icon={faWhatsapp} className="logo-icon" />
            <span className="logo-text">Wappfy</span>
          </div>
          <p className="logo-subtitle">{t('whatsappApiSubtitle')}</p>
        </div>

        {/* Verification Content */}
        <div className="verification-content">
          <div className="envelope-icon">
            <FontAwesomeIcon icon={faEnvelopeOpen} className="envelope" />
          </div>

          <div className="verification-text">
            <h2>{t('verification.title')}</h2>
            <p>{t('verification.instruction')}</p>
            <p>
              {t('verification.sentTo')}{' '}
              <span className="email-highlight">{email ? email : t('signup.placeholderEmail')}</span>
            </p>
          </div>

          <div className="resend-section">
            <button className="resend-button" onClick={handleResend} disabled={loading}>
              <FontAwesomeIcon icon={faPaperPlane} />
              {loading ? t('fpassword.resend') + '...' : t('verification.resend')}
            </button>
            {success && <div style={{ color: '#10b981', fontSize: 14, marginTop: 8 }}>{success}</div>}
            {error && <div style={{ color: '#ef4444', fontSize: 14, marginTop: 8 }}>{error}</div>}
          </div>

          <div className="additional-info">
            <p>{t('verification.notReceived')}</p>
          </div>
          
          <div className="back-to-login">
            <Link
              to="/"
              className="signin-link"
              aria-label={t('verification.backToLogin')}
            >
              {t('verification.backToLogin')}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailVerification;